import type {InputHTMLAttributes, ReactNode, Ref} from "react";
import {css} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {SearchIcon} from "@pg-design/icons-module";

interface IProps {
    /** `getInputProps(...)` from the combobox, or plain props while the mobile layer owns the combobox. */
    inputProps: InputHTMLAttributes<HTMLInputElement> & {id: string};
    inputRef: Ref<HTMLInputElement>;
    /** Visually hidden label of the input. */
    label: string;
    /** `SearchComboboxFieldControls` - × or the spinner after the input; nothing on the mobile trigger. */
    controls?: ReactNode;
    inputDataTestId?: string;
}

/**
 * The hero search field, markup and styles as they were in the hub (the look must not change): white pill with the
 * search glyph and the input, plus the field controls slot. The same element serves the desktop dropdown and, read
 * only, as the trigger of the mobile layer - it is never remounted when the mode changes.
 */
export const PricesSearchField = (props: IProps) => {
    const {inputProps, inputRef, label, controls, inputDataTestId} = props;

    return (
        <div className={fieldStyle}>
            <label htmlFor={inputProps.id} className={visuallyHidden()}>
                {label}
            </label>

            <span className={fieldIconStyle}>
                <SearchIcon size="2.4" fill="var(--colors-secondary)" />
            </span>

            <input ref={inputRef} type="text" {...inputProps} className={inputStyle} data-testid={inputDataTestId} />

            {controls ? <span className={controlsStyle}>{controls}</span> : null}
        </div>
    );
};

const fieldStyle = css({
    position: "relative",
    display: "flex",
    flex: "1 1 auto",
    alignItems: "center",
    boxSizing: "border-box",
    width: "100%",
    height: "5.6rem",
    pl: "2.4rem",
    pr: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: "999px",
    boxShadow: "1",

    md: {
        width: "auto",
        maxWidth: "56rem",
        height: "7.2rem"
    }
});

const fieldIconStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "center",
    marginRight: 1
});

const inputStyle = css({
    flex: "1 1 auto",
    minWidth: 0,
    // The placeholder is wider than the 320px field; truncate it visibly instead of cutting it.
    textOverflow: "ellipsis",
    height: "100%",
    padding: 0,
    color: "var(--colors-secondary)",
    fontSize: "1.519rem",
    lineHeight: "2.4rem",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",

    md: {
        fontSize: "1.772rem",
        lineHeight: "2.8rem"
    },

    _placeholder: {
        color: "var(--colors-gray-700)"
    }
});

// The controls sit 1.2rem after the input, centred; absent while the field is empty, so the field looks as before.
const controlsStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "center",
    marginLeft: "1.2rem"
});
import type {InputHTMLAttributes, ReactNode, Ref} from "react";
import {css} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {SearchIcon} from "@pg-design/icons-module";

interface IProps {
    /** `getInputProps(...)` from the combobox, or plain props while the mobile layer owns the combobox. */
    inputProps: InputHTMLAttributes<HTMLInputElement> & {id: string};
    inputRef: Ref<HTMLInputElement>;
    /** Visually hidden label of the input. */
    label: string;
    /** `SearchComboboxFieldControls` - × or the spinner after the input; nothing on the mobile trigger. */
    controls?: ReactNode;
    inputDataTestId?: string;
}

/**
 * The hero search field, markup and styles as they were in the hub (the look must not change): white pill with the
 * search glyph and the input, plus the field controls slot. The same element serves the desktop dropdown and, read
 * only, as the trigger of the mobile layer - it is never remounted when the mode changes.
 */
export const PricesSearchField = (props: IProps) => {
    const {inputProps, inputRef, label, controls, inputDataTestId} = props;

    return (
        <div className={fieldStyle}>
            <label htmlFor={inputProps.id} className={visuallyHidden()}>
                {label}
            </label>

            <span className={fieldIconStyle}>
                <SearchIcon size="2.4" fill="var(--colors-secondary)" />
            </span>

            <input ref={inputRef} type="text" {...inputProps} className={inputStyle} data-testid={inputDataTestId} />

            {controls ? <span className={controlsStyle}>{controls}</span> : null}
        </div>
    );
};

const fieldStyle = css({
    position: "relative",
    display: "flex",
    flex: "1 1 auto",
    alignItems: "center",
    boxSizing: "border-box",
    width: "100%",
    height: "5.6rem",
    pl: "2.4rem",
    pr: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: "999px",
    boxShadow: "1",

    md: {
        width: "auto",
        maxWidth: "56rem",
        height: "7.2rem"
    }
});

const fieldIconStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "center",
    marginRight: 1
});

const inputStyle = css({
    flex: "1 1 auto",
    minWidth: 0,
    // The placeholder is wider than the 320px field; truncate it visibly instead of cutting it.
    textOverflow: "ellipsis",
    height: "100%",
    padding: 0,
    color: "var(--colors-secondary)",
    fontSize: "1.519rem",
    lineHeight: "2.4rem",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",

    md: {
        fontSize: "1.772rem",
        lineHeight: "2.8rem"
    },

    _placeholder: {
        color: "var(--colors-gray-700)"
    }
});

// The controls sit 1.2rem after the input, centred; absent while the field is empty, so the field looks as before.
const controlsStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "center",
    marginLeft: "1.2rem"
});
